import React, { useState, useRef } from "react";
import { Tooltip } from "antd";

const EllipsisTooltip = ({ text, style = {}, mouseEnterDelay = 0.3, children }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  const checkTruncation = () => {
    if (textRef.current) {
      const element = textRef.current;
      const parent = element.parentElement;
      const isSelfOver = element.scrollWidth > element.clientWidth;
      const isParentOver = parent ? parent.scrollWidth > parent.clientWidth : false;
      setIsTruncated(isSelfOver || isParentOver);
    }
  };

  return (
    <Tooltip title={isTruncated ? text : ""} mouseEnterDelay={mouseEnterDelay}>
      <span
        ref={textRef}
        onMouseEnter={checkTruncation}
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          ...style,
        }}
      >
        {children || text}
      </span>
    </Tooltip>
  );
};

export default EllipsisTooltip;
